import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ConfirmDialog as ModalDelete } from '@playbookux/playbook-web-core';

import {
  Container,
  Content,
  DefaultFlag,
  Link,
  Text,
  TextError,
} from './styles';

const Card = (props) => {
  const {
    error,
    onRemove,
    onUpdate,
    paymentMethod,
  } = props;

  const {
    id,
    isDefault,
    card: {
      brand,
      last4,
      expMonth,
      expYear,
    },
  } = paymentMethod;

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);
    onRemove(id);
    setShow(false);
  };

  const handleUpdate = () => {
    onUpdate(id);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleOpen = () => {
    setShow(true);
  };

  const expiresAt = `${_.padStart(expMonth.toString(), 2, '0')}/${expYear}`;

  return (
    <Container>
      <Content>
        <Text>
          {`${_.capitalize(brand)} ending in ${last4} expires ${expiresAt}`}
        </Text>

        <Text
          remove
          onClick={handleOpen}
        >
          Remove
        </Text>

        <ModalDelete
          handleConfirm={handleConfirm}
          title="Do you want to remove your card?"
          confirmText="Yes, remove card"
          cancelText="Cancel, don't remove card"
          show={show}
          handleClose={handleClose}
          errorMessage={error}
          loading={loading}
        />
      </Content>

      {isDefault && (
        <DefaultFlag>
          <Text flag>Default</Text>
        </DefaultFlag>
      )}

      {!isDefault && (
        <Link onClick={handleUpdate}>
          Set as default payment method
        </Link>
      )}

      {error && (
        <TextError>
          {error}
        </TextError>
      )}
    </Container>
  );
};

Card.propTypes = {
  paymentMethod: PropTypes.shape({
    id: PropTypes.string,
    isDefault: PropTypes.bool.isRequired,
    card: PropTypes.shape({
      brand: PropTypes.string,
      last4: PropTypes.string,
      expMonth: PropTypes.number,
      expYear: PropTypes.number,
    }),
  }).isRequired,
  error: PropTypes.string,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

Card.defaultProps = {
  error: null,
};

export default Card;
